import { Autocomplete, Box, Button, Dialog, Divider, IconButton, MenuItem, Paper, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import * as Icon from "@mui/icons-material";
import { CommonContext } from '../../store/context/commonContext';
import CommonService from '../../services/misc';
import { extractDataFromArray } from '../../utils/common';
import { useNavigate } from 'react-router';
import { AccessPackageContext } from '../../store/context/packageContext';

function AddPackagesPopup({ open, setOpen, selectedProperty, listingSeq }) {
  const navigate = useNavigate();
  const { screenWidth, isNineHundred } = CommonContext()
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [activities, setActivities] = useState({});
  const { setpackageType } = AccessPackageContext()


  const handleActivitySelect = (activity) => {
    setSelectedActivity(activity);
  };

  // Fetch activities data
  useEffect(() => {
    CommonService.getAllActivitiesDetails((data) => {
      setActivities(extractDataFromArray(data, ['access', 'activities'], {}))
    })
  }, []);

  // Convert activities object to array for dropdown
  const activitiesArray = Object.entries(activities).map(([key, activity]) => ({
    id: key,
    ...activity
  }));

  const clickedGetStarted = () => {
    setpackageType(extractDataFromArray(selectedActivity, ['id'], ''))
    navigate(`/createPackage?listing_seq=${listingSeq}&activity=${extractDataFromArray(selectedActivity, ['id'], '')}`, {
      state: {
        selectedProperty: selectedProperty,
        selectedActivity: selectedActivity
      }
    });

  };


  return (
    <Dialog open={open} sx={{ "& .MuiDialog-paper": { maxWidth: 'unset !important', maxHeight: '100%', width: 500 } }}>
      <Box>
        <Box sx={{ p: 2.5, display: "flex", justifyContent: 'space-between', alignItems: screenWidth > 500 ? 'center' : 'flex-start' }}>
          <IconButton
            onClick={() => { setOpen(false); }}
            sx={{ position: 'absolute', top: 16, left: 16, }}
          >
            <Icon.ArrowBackOutlined />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: 700, mx: 'auto' }}>Add a Package</Typography>
          <IconButton
            onClick={() => { setOpen(false) }}
            sx={{ position: 'absolute', top: 16, right: 16, }}
          >
            <Icon.Close />
          </IconButton>
        </Box>
        <Divider />

        <Box sx={{ px: isNineHundred ? 2 : 3, pt: 2, pb: 4 }}>
          <Box>
            <Typography variant="body1" fontWeight={600} sx={{ pb: 2 }}>Package added to the Property Listing -</Typography>
            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'space-between' }}>
              {selectedProperty}
            </Box>
          </Box>
          <Box sx={{ mt: 4 }}>
            <Typography variant="body1" fontWeight={600} sx={{ pb: 2 }}>Select activity for this package</Typography>
            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'space-between' }}>
              <Autocomplete
                fullWidth
                value={selectedActivity}
                onChange={(event, newValue) => handleActivitySelect(newValue)}
                options={activitiesArray}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Activity Type" fullWidth />
                )}
                renderOption={(props, option) => (
                  <MenuItem component="li" {...props}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Typography>{option.label}</Typography>
                    </Box>
                  </MenuItem>
                )}
                PaperComponent={(props) => <Paper elevation={3} {...props} />}
              />
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "end", gap: 1, width: "100%", mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={clickedGetStarted}
              disabled={!selectedProperty || !selectedActivity}
            >
              Get Started
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}

export default AddPackagesPopup